import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const BonesIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M12.0597 5.56418C11.953 5.45747 11.7763 5.44157 11.6696 5.54827L5.54827 11.6696C5.44157 11.7763 5.45747 11.953 5.56418 12.0597C6.23681 12.7323 6.23681 13.8229 5.56418 14.4955C4.89155 15.1682 3.80099 15.1682 3.12836 14.4955C2.81643 14.1836 2.64915 13.7818 2.62653 13.3735C2.21821 13.3508 1.8164 13.1836 1.50448 12.8716C0.831842 12.199 0.831842 11.1085 1.50448 10.4358C2.17711 9.76319 3.26766 9.76319 3.9403 10.4358C4.047 10.5425 4.22366 10.5584 4.33036 10.4517L10.4517 4.33036C10.5584 4.22366 10.5425 4.047 10.4358 3.9403C9.76319 3.26766 9.76319 2.17711 10.4358 1.50448C11.1085 0.831842 12.199 0.831841 12.8716 1.50448C13.1836 1.8164 13.3508 2.21821 13.3735 2.62653C13.7818 2.64915 14.1836 2.81643 14.4955 3.12836C15.1682 3.80099 15.1682 4.89155 14.4955 5.56418C13.8229 6.23681 12.7323 6.23681 12.0597 5.56418Z"
		></path>
		<path
			fill="currentColor"
			d="M6.93934 5.72143L5.54827 4.33036C5.44157 4.22366 5.45748 4.047 5.56418 3.9403C6.23681 3.26766 6.23681 2.17711 5.56418 1.50448C4.89155 0.831842 3.80099 0.831841 3.12836 1.50448C2.81643 1.8164 2.64915 2.21821 2.62653 2.62653C2.21821 2.64915 1.8164 2.81643 1.50448 3.12836C0.831842 3.80099 0.831842 4.89154 1.50448 5.56418C2.17711 6.23681 3.26766 6.23681 3.9403 5.56418C4.047 5.45747 4.22366 5.44157 4.33036 5.54827L5.72143 6.93934L6.93934 5.72143Z"
		></path>
		<path
			fill="currentColor"
			d="M10.2786 9.06066L9.06066 10.2786L10.4517 11.6696C10.5584 11.7763 10.5425 11.953 10.4358 12.0597C9.76319 12.7323 9.76319 13.8229 10.4358 14.4955C11.1085 15.1682 12.199 15.1682 12.8716 14.4955C13.1836 14.1836 13.3508 13.7818 13.3735 13.3735C13.7818 13.3508 14.1836 13.1836 14.4955 12.8716C15.1682 12.199 15.1682 11.1085 14.4955 10.4358C13.8229 9.76319 12.7323 9.76319 12.0597 10.4358C11.953 10.5425 11.7763 10.5584 11.6696 10.4517L10.2786 9.06066Z"
		></path>
	</svg>
))
